import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-progressbar',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './progressbar.component.html',
  styleUrl: './progressbar.component.scss'
})
export class ProgressbarComponent {
  @Input() organizationKey: string = "";
  @Input() projectKey: string = "";
  @Input() userId: string = "";
  @Input() fieldKey: string = "";
  @Input() contentKey: string = "";
  @Input() aggregatedContent: string = "";
  @Input() fullWidth: boolean = true;
  @Input() content = "";
  @Input() isReadOnly: boolean = false;
  @Input() isTaskPercentage = false // if true, the progress bar is a task progress bar, if false, it is a regular progress bar
  @Output() valueChange = new EventEmitter<{ "content": string, "fieldKey": string }>();
  value: number = 0;
  label: string = "";
  obj: { "value": number, "label": string } = { "value": 0, "label": "" };

  @ViewChild('bar', { static: true }) bar!: ElementRef<HTMLDivElement>;

  dragging = false;

  ngAfterViewInit() {
    if (this.content != "") {
      this.convertToObject()
    }
  }

  convertToObject() {
    try {
    this.obj = JSON.parse(this.content)
      this.value = this.obj.value || 0
      this.label = this.obj.label || ""
    } catch (error) {
      this.value = 0
      this.label = ""
    }
  }

  convertToJson() {
    this.obj.value = this.value
    this.obj.label = this.label
    this.content = JSON.stringify(this.obj);
  }

  clamp(val: number) {
    return Math.max(0, Math.min(100, val));
  }

  onBarClick(event: MouseEvent) {
    if (this.isReadOnly == true) {
      return
    }
    this.updateValueFromEvent(event);
    this.convertToJson();
    this.valueChange.emit({ "content": this.content, "fieldKey": this.fieldKey });
  }

  onThumbMouseDown(event: MouseEvent) { // when the thumb is clicked, we start dragging
    if (this.isReadOnly == true) {
      return
    }
    event.preventDefault();
    this.dragging = true;
    window.addEventListener('mousemove', this.onMouseMove);
    window.addEventListener('mouseup', this.onMouseUp);
  }

  onMouseMove = (event: MouseEvent) => {
    this.updateValueFromEvent(event);
  };

  onMouseUp = () => { // when the mouse is released, we stop dragging
    this.dragging = false;
    window.removeEventListener('mousemove', this.onMouseMove);
    window.removeEventListener('mouseup', this.onMouseUp);
    this.convertToJson();
    this.valueChange.emit({ "content": this.content, "fieldKey": this.fieldKey });
  };

  updateValueFromEvent(event: MouseEvent) {
    const barRect = this.bar.nativeElement.getBoundingClientRect();
    const x = event.clientX - barRect.left;
    let percent = (x / barRect.width) * 100;
    percent = this.clamp(percent);
    this.value = percent;
  }

}
